import vueI18n from '@/i18n/locale'

// 货币单位
export const MONETARY_UNIT = {
  PE: 'S/.',
  CR: '₡',
  CO: '$',
  MX: '$',
}

// 付款方式
export const PAYMENT_METHOD = [
  {
    label: vueI18n.t('FoodB_calculator_tLev_cAgO' /** 电子支付 */),
    value: 1,
  },
  {
    label: vueI18n.t('FoodB_calculator_rMFF_EMXI' /** 现金 */),
    value: 2,
  },
]

// 是否RFC有效 | 是否为瓜纳华托州商家
export const IS_RFC_EFFICIENTLY = [
  {
    label: vueI18n.t('FoodB_calculator_pEyx_wJvY' /** 是 */),
    value: 1,
  },
  {
    label: vueI18n.t('FoodB_calculator_hmWL_DEwB' /** 否 */),
    value: 2,
  },
]

// 税务主体
export const TAX_ENTITY = [
  {
    label: vueI18n.t('FoodB_calculator_RWNx_Xkrf' /** 个人 */),
    value: 1,
  },
  {
    label: vueI18n.t('FoodB_calculator_EeIc_TwiG' /** 公司 */),
    value: 2,
  },
]
